import EntityModel from '@/common/models/entity-model';

export default class KYCDocumentModel extends EntityModel {
    hydrate({
        id = null,
        customerId = null,
        documentType = null,
        documentMatches = null,
        fileId = null,
        processedTime = null,
        rejectionReason = null,
        status = null,
        createdTime = null,
        updatedTime = null,
    } = {}) {
        this.id = id;
        this.customerId = customerId;
        this.documentType = documentType;
        this.documentMatches = documentMatches;
        this.fileId = fileId;
        this.processedTime = processedTime;
        this.rejectionReason = rejectionReason;
        this.status = status;
        this.createdTime = createdTime;
        this.updatedTime = updatedTime;
        // Derived properties
        const statusMap = KYCDocumentModel.DocumentStatus;
        this.isPending = this.status === statusMap.pending;
        this.isInProgress = this.status === statusMap.inProgress;
        this.isAccepted = this.status === statusMap.accepted;
        this.isRejected = this.status === statusMap.rejected;
        this.hasReview = this.isAccepted || this.isRejected;
    }

    static DocumentStatus = {
        pending: 'pending',
        inProgress: 'in-progress',
        accepted: 'accepted',
        rejected: 'rejected',
    };

    static RejectionTypes = {
        documentUnreadable: 'document-unreadable',
        documentExpired: 'document-expired',
        documentNotMatching: 'document-not-matching',
        underagePerson: 'underage-person',
        other: 'other',
    };
}
